import { render, staticRenderFns } from "./DownloadStats.vue?vue&type=template&id=9565edf4"
import script from "./DownloadStats.vue?vue&type=script&lang=js"
export * from "./DownloadStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports